import { lazy, Suspense } from 'react'
import { PublicI18nProvider, usePublicI18n } from './publicI18n'
import { PublicSiteTelemetry } from './components/PublicSiteTelemetry'
import { LandingPage } from './pages/landing/LandingPage'

const LandingRouterApp = lazy(() => import('./LandingRouterApp'))

function LandingHomepage() {
  const { language } = usePublicI18n()
  return (
    <>
      <PublicSiteTelemetry language={language} />
      <LandingPage />
    </>
  )
}

export default function LandingApp() {
  if (window.location.pathname !== '/') {
    return (
      <Suspense fallback={null}>
        <LandingRouterApp />
      </Suspense>
    )
  }

  return (
    <PublicI18nProvider>
      <LandingHomepage />
    </PublicI18nProvider>
  )
}
